import gql from 'graphql-tag'

export const TRACKING_TEMPORARY_LIST = gql`
  query TemporaryLiveViewsPaginated($filter: GetTemporaryLiveViewsFilter) {
    temporaryLiveViewsPaginated(filter: $filter) {
      isSuccessful
      message
      temporaryLiveViewsPaginated {
        data {
          temporaryLvId
          companyId
          createdBy
          name
          accessToken
          shortKey
          createdOn
          expiresOn
          note
          pickedColumns
          alertCodes
          popupDuration
          status
          customerContract {
            uuid
            number
          }
          vehicleIds {
            temporaryLvId
            vehicleId
          }
        }
        pagination {
          total
          page
          show
        }
      }
    }
  }
`

export const TRACKING_TEMPORARY_DETAIL = gql`
  query TemporaryLiveView($filter: GetTemporaryLiveViewFilter!) {
    temporaryLiveView(filter: $filter) {
      isSuccessful
      message
      temporaryLiveView {
        temporaryLvId
        companyId
        createdBy
        name
        accessToken
        shortKey
        createdOn
        expiresOn
        note
        pickedColumns
        alertCodes
        popupDuration
        status
        customerContract {
          uuid
          number
          maxMileage
          customer {
            name
            contacts {
              email
            }
          }
          vehicles {
            vehicleId
            totalMileage
          }
        }
        vehicleIds {
          temporaryLvId
          vehicleId
        }
        contacts {
          contactId
          createdBy
          createdOn
          label
          phoneNumber
          location {
            fullName
            id {
              ... on TemporaryLvContactsLocationIdInt {
                masterDataValue: value
                __typename
              }
              ... on TemporaryLvContactsLocationIdString {
                googleValue: value
                __typename
              }
            }
            name
            address {
              lat
              lng
            }
          }
        }
      }
    }
  }
`

export const CREATE_TRACKING_TEMPORARY = gql`
  mutation CreateTemporaryLiveView($input: CreateTemporaryLiveViewInput!) {
    createTemporaryLiveView(input: $input) {
      isSuccessful
      message
      temporaryLiveView {
        temporaryLvId
        accessToken
        shortKey
      }
    }
  }
`

export const UPDATE_TRACKING_TEMPORARY = gql`
  mutation UpdateTemporaryLiveView($input: UpdateTemporaryLiveViewInput) {
    updateTemporaryLiveView(input: $input) {
      isSuccessful
      message
    }
  }
`

export const DELETE_TRACKING_TEMPORARY = gql`
  mutation DeleteTemporaryLiveView($input: DeleteTemporaryLiveViewInput!) {
    deleteTemporaryLiveView(input: $input) {
      isSuccessful
      message
    }
  }
`

export const UPSERT_CONTACT_LOCATION_TEMPORARY = gql`
  mutation UpsertContactLocationToTempLiveView($input: UpsertContactLocationToTempLiveViewType!) {
    upsertContactLocationToTempLiveView(input: $input) {
      isSuccessful
      errorName
      errorCode
      message
      status
    }
  }
`
